import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import { ComponentProps, CSSProperties } from 'react'

import { cn } from '@/shared/lib'

export { Subway } from './subway'

const badgeVariants = cva(
  [
    'typo-caption2 inline-flex h-[18px] w-fit min-w-[18px] shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border-[1.5px] border-[var(--badge-color)] px-1 whitespace-nowrap',
    '[&>svg]:pointer-events-none [&>svg]:size-3',
  ],
  {
    variants: {
      variant: {
        solid: 'bg-[var(--badge-color)] font-medium text-white',
        outline: 'bg-white font-bold text-[var(--badge-color)]',
      },
    },
  },
)

type Props = ComponentProps<'span'> &
  VariantProps<typeof badgeVariants> & {
    asChild?: boolean
    color?: string
  }

export const Badge = ({
  color,
  variant = 'solid',
  className,
  asChild = false,
  ...props
}: Props) => {
  const Component = asChild ? Slot : 'span'

  return (
    <Component
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      style={{ '--badge-color': color } as CSSProperties}
      {...props}
    />
  )
}
